import { useShallow } from 'zustand/shallow';
import { useTranslations } from 'next-intl';
import type { ChatTabType } from '../store/chatTabsStore';
import { useChatInstancesStore } from '../store/chatInstancesStore';
import { resolveChatTabDisplayTitle } from '../components/chat/chatTabDisplayTitle';

export function useChatTabDisplayTitle(tab: ChatTabType): string {
  const tCopilot = useTranslations('chat.copilot');

  return useChatInstancesStore(
    useShallow((state) => {
      const chat = state.chats.get(tab.chatId);
      const queuedCount = state.getQueuedMessages({
        chatId: tab.chatId,
      }).length;

      return {
        revision: `${chat?.messages.length ?? 0}:${queuedCount}`,
        title: resolveChatTabDisplayTitle({
          tab,
          fallbackTitle: tCopilot('newChatTitle'),
          draftTitle: (preview) => tCopilot('draftTitle', { preview }),
        }),
      };
    }),
  ).title;
}
